import React from 'react';
import * as Styled from '../LoyaltyPageReport.styles';
import SearchModal from '../../../components/SearchModal';
import networksArrow from '../../../global/media/networks-arrow.svg';

interface NetworkSelectorProps {
  isOpen: boolean;
  selectedName: string;
  sources: { code: string; name: string }[];
  onToggle: () => void;
  onClose: () => void;
  onSelect: (code: string, name: string) => void;
  hideAll?: boolean;
}

const NetworkSelector = ({
  isOpen,
  selectedName,
  sources,
  onToggle,
  onClose,
  onSelect,
  hideAll,
}: NetworkSelectorProps) => (
  <Styled.PickersTop>
    <Styled.NetworkBlock>
      <div className="selected-network" onClick={onToggle}>
        {selectedName}
        <img src={networksArrow} alt="networks-arrow" />
      </div>
      {isOpen && (
        <SearchModal
          onClose={onClose}
          data={sources}
          setData={onSelect}
          variant="networks"
          hideAll={hideAll}
        />
      )}
    </Styled.NetworkBlock>
  </Styled.PickersTop>
);

export default NetworkSelector;
